<template>
<!-- eslint-disable vue/valid-v-slot -->
  <v-container fluid>
   <v-btn
      :disabled="countInProgress"
      color="primary" class="ma-3 d-print-none"
      @click="initCount">
      <v-icon class="me-3">mdi-playlist-edit</v-icon>{{$t('Start new Count')}}
   </v-btn>
   <v-btn color="primary" class="ma-3 d-print-none"
      @click="back">
      {{$t('Back')}}
   </v-btn>
    <div class="title primary--text mb-2">
      <span class="me-12 ms-2">{{$t('Inventory Adjustments')}}</span>
   </div>

   <printHeader class="d-none d-print-flex" ></printHeader>
   <v-layout>
      <!-- <v-flex xs12 md12> -->
         <v-switch inset class="me-10 my-2 d-print-none" color="primary darken-2" v-model="includeTmr" :label="$t('Include TMRs')"></v-switch>

         <v-btn
            :disabled="!countInProgress"
            color="primary" class="my-2 mx-8 d-print-none"
            @click="cancel">
            <v-icon class="me-2">mdi-cancel</v-icon>{{$t('Cancel')}}
         </v-btn>

         <v-btn
            :disabled="!countInProgress"
            color="primary" class="ma-2 d-print-none"
            @click="apply">
            <v-icon class="me-2">mdi-playlist-check</v-icon>{{$t('Apply Adjustments')}}
         </v-btn>
      <!-- </v-flex> -->
   </v-layout>
   <v-layout>
      <v-flex xs12 sm10 md8>
      <v-data-table
         :headers="headers"
         :items="snapshot"
         item-key="index"
         hide-default-footer
         :hide-default-header="!countInProgress"

         :items-per-page="200"
         @page-count="pageCount = $event"
         search="isTmr"
         :custom-filter="filter"
         no-sort
      >
      <template v-slot:no-data>
         <span class="primary--text text--lighten-2">{{ $i18n.t('Click start Count')}}</span>
      </template>
      <template v-slot:item.code="{ item }">
         <span :class="{'grey--text': item.isTmr }">{{ item.code }}</span>
      </template>
      <template v-slot:item.name="{ item }">
         <span :class="{'grey--text': item.isTmr }">{{ item.name }}</span>
      </template>

      <template v-slot:item.currentCount="{ item }">
        <span class="me-4">{{ item.currentCount ? item.currentCount : 0 | kgString}}</span>
      </template>
      <template v-slot:item.newCount="{ item }">
        <v-text-field solo background-color="grey"
          dense hide-details v-model="item.newCount" v-on:change="changed(item)" :suffix="$i18n.t('Kg')"
        ></v-text-field>
      </template>
      <template v-slot:item.use="{ item }">
        <v-simple-checkbox v-model="item.use"></v-simple-checkbox>
      </template>
      </v-data-table>
      </v-flex>
   </v-layout>
  </v-container>
</template>

<script>
import printHeader from "../components/common/PrintHeader";
export default {
   name: "inventory",
    components: {
     "printHeader": printHeader
    },
data() {
    return {
      countInProgress: false,
      snapshot: [],
      includeTmr: false,
      headers: [
        { text: this.$i18n.t('Code'), width: "15%", align: "left", value: "code"},
        { text: this.$i18n.t('Name'), width: "30%", align: "left", value: "name"},
        { text: this.$i18n.t('Current Count'), width: "20%", align: "right", value: "currentCount"},
        { text: this.$i18n.t('New Count'), width: "20%", align: "right", value: "newCount"},
        { text: this.$i18n.t('Use'), width: "15%", align: "center", value: "use"},
      ]
  }
},
created() {
   this.$store.dispatch("loadStoredInvCount").then( (list) => {
      this.snapshot = list;
      this.countInProgress = list.length > 0 ;
   });

},
methods: {
   initCount() {
      this.$store.dispatch("generateInvCount").then((list) => {
         this.snapshot = list;
         this.countInProgress = true;
      });
   },
   changed: function(val) {
      val.use = true;
      this.$store.dispatch("saveInvCount", this.snapshot);

   },
   filter(value, search, item) {
      return item.isTmr ? this.includeTmr : true
   },
   apply() {
      //Make actual inv adjustment and clear list
      this.$store.dispatch("applyInvAdjustments").then(affected =>
         this.$root.$globalSnackbar(this.$i18n.t('adjustment apply', [affected]), "info"));
      this.cancel();
   },
   cancel() {
      this.$store.dispatch("clearInvCount");
      this.snapshot = [];
      this.countInProgress = false;
   },
   back() {
      this.$root.$router.go(-1);
   }

}

}
</script>

<style>

</style>